import copy from 'copy-to-clipboard';
import { Copy } from 'lucide-react';
import { useNotify, useTranslate } from 'ra-core';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface Props {
  text: string;
  className?: string;
}

function CopyButton({ text, className }: Props) {
  const notify = useNotify();
  const t = useTranslate();

  return (
    <Button
      aria-label="Copy"
      variant="ghost"
      size="icon"
      className={cn('size-7', className)}
      onClick={() => {
        if (copy(text)) {
          notify(t('common.text.copied'), { type: 'success' });
        }
      }}
    >
      <Copy className="size-3.5" />
    </Button>
  );
}

export default CopyButton;
